import {Form, Input} from 'antd';

type TitleProps = {
    autoFocus?: boolean;
}

export function Title({autoFocus = false}: TitleProps) {
    return (
        <Form.Item
            label={'Title'}
            name={'title'}
            rules={[{required: true, message: 'Please input the title'}]}
        >
            <Input id={'title'} placeholder={'e.g. Concert Tickets'} autoFocus={autoFocus}/>
        </Form.Item>
    )
}
